import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "steps",
    "enableAppointment",
    "submitButton",
    "professionalsNextButton",
    "totalSteps",
  ]

  handleNextStep(event) {
    event.preventDefault();
    const stepElements = this.stepsElements()
    this.currentStep = this.currentStep || 0;
    this.updateSubmitButton()
    stepElements[this.currentStep].classList.add("tw-hidden");
    stepElements[this.currentStep + 1].classList.remove("tw-hidden");
    this.currentStep += 1;
  }

  handlePreviousStep(event) {
    event.preventDefault();
    const stepElements = this.stepsElements()
    this.currentStep = this.currentStep || 0;
    stepElements[this.currentStep].classList.add("tw-hidden");
    stepElements[this.currentStep - 1].classList.remove("tw-hidden");
    this.currentStep -= 1;
  }

  handleProfessionalsStep(event) {
    let hasEmptyInput = false;

    this.element.querySelectorAll(`.professional-specialty-input`).forEach(input => {
      if (!input.value && !input.hasAttribute("disabled")) {
        hasEmptyInput = true;
      }
    })

    if (hasEmptyInput) {
      event.preventDefault();
      this.element.reportValidity()
      return false;
    }

    this.handleNextStep(event);
  }

  stepsElements(){
    return this.stepsTargets.filter((step, index) => {
      if (this.enableAppointmentTarget.checked) {
        return true
      }

      return index != 2
    })
  }

  updateSubmitButton(){
    if (!this.enableAppointmentTarget.checked) {
      this.submitButtonTarget.removeAttribute("disabled")
      return
    }
  }

  updateStepsNumber(){
    const numberOfSteps = this.stepsElements().length
    this.totalStepsTargets.map(step => step.innerText = numberOfSteps)
  }

  handleEnableAppointmentChange(){
    this.updateStepsNumber()
    this.syncSpecialtyInputs()
  }

  syncSpecialtyInputs(){
    this.element.querySelectorAll(`.professional-specialty-input`).forEach(input => {
      if(input.hasAttribute("required")){
        input.setAttribute("data-required", "required")
        input.removeAttribute("required")
        return
      }
      if(input.hasAttribute("data-required")){
        input.setAttribute("required", "required")
        input.removeAttribute("data-required")
        return
      }
    })
  }
}
